import React from 'react'

import { OrgChartWidget } from '@rewardops/replit/src/components/OrgChartWidget'

import { PAWSectionType } from './paw-section-types'

export const Heirarchy: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  return (
    <section data-testid={content?.sectionId} id={content?.sectionId}>
      <h2 className="mb-6 text-xl font-semibold">{content?.title}</h2>
      {/* TODO: incorporate data in the heirarchy */}
      <OrgChartWidget />
    </section>
  )
}
